import { render, staticRenderFns } from "./ImageComparison.vue?vue&type=template&id=ed3b27c6&scoped=true"
import script from "./ImageComparison.vue?vue&type=script&lang=js"
export * from "./ImageComparison.vue?vue&type=script&lang=js"
import style0 from "./ImageComparison.vue?vue&type=style&index=0&id=ed3b27c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3b27c6",
  null
  
)

export default component.exports